import React from 'react';
import { TextField } from '@mui/material';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

interface TimeFieldProps {
  label?: string;
  name: string;
  value: string | null;
  onChange: (value: string | null) => void;
  error?: boolean;
  helperText?: string;
}

const TimeField: React.FC<TimeFieldProps> = ({ label, name, value, onChange, error, helperText }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        label={label}
        value={value ? dayjs(value, 'HH:mm:ss') : null}
        onChange={(value /*: PickerValue*/) => {
          if (dayjs.isDayjs(value)) {
            onChange(value.format('HH:mm:ss'));
          } else {
            onChange(null);
          }
        }}
        slotProps={{
          textField: {
            fullWidth: true,
            error: error,
            helperText: helperText,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default TimeField;
